const filmLocationRouter = {
  route: null,
  name: null,
  title: '协拍服务',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont el-icon-help',
  filePath: 'view/cooperation_service/', // 文件路径
  order: 15,
  inNav: true,
  permission: ['协拍服务'],
  children: [
    {
      title: '添加服务',
      type: 'view',
      name: 'addCooperationService',
      route: '/cooperationService/add',
      filePath: 'view/cooperation_service/create.vue',
      inNav: true,
      icon: 'iconfont el-icon-document-add',
      permission: ['添加服务'],
    },
    {
      title: '服务列表',
      type: 'view',
      name: 'cooperationServiceList',
      route: '/cooperationService/list',
      filePath: 'view/cooperation_service/list.vue',
      inNav: true,
      icon: 'iconfont el-icon-notebook-2',
      permission: ['服务列表'],
    },
    {
      title: '服务分类',
      type: 'view',
      name: 'typesList',
      route: '/cooperationService/types',
      filePath: 'view/cooperation_service/types.vue',
      inNav: true,
      icon: 'iconfont el-icon-film',
      permission: ['服务分类'],
    },
  ],
}

export default filmLocationRouter
